function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 14.77,
  cy: 22.17,
  r: 14.77
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "16.05 11.3 16.05 0 4.33 11.72 16.05 11.3"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 16.05,
  width: 3.9,
  height: 11.72
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 50.26,
  cy: 22.17,
  r: 14.77
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "51.54 11.3 51.54 0 39.81 11.72 51.54 11.3"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 51.54,
  width: 3.9,
  height: 11.72
})));

var SvgQuoteStart = function SvgQuoteStart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.03 36.94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuoteStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/QuoteStart.e095a5b5.svg";
export { ForwardRef as ReactComponent };